import * as types from '../types';
import { ISetupApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class SetupHttpApi extends HttpApi implements ISetupApi {
  async getSetup(): Promise<types.SetupProgress> {
    return (await this.http.get<types.APIResponse<types.SetupProgress>>('/setup')).data.data;
  }

  async skipSetupStep(key: types.SetupStepKey): Promise<types.SetupProgress> {
    return (await this.http.post<types.APIResponse<types.SetupProgress>>(`/setup/steps/${encodeURIComponent(key)}/skip`)).data.data;
  }

  async unskipSetupStep(key: types.SetupStepKey): Promise<types.SetupProgress> {
    return (await this.http.delete<types.APIResponse<types.SetupProgress>>(`/setup/steps/${encodeURIComponent(key)}/skip`)).data.data;
  }

  async markSetupStepDone(key: types.SetupStepKey): Promise<types.SetupProgress> {
    return (await this.http.post<types.APIResponse<types.SetupProgress>>(`/setup/steps/${encodeURIComponent(key)}/done`)).data.data;
  }

  async unmarkSetupStepDone(key: types.SetupStepKey): Promise<types.SetupProgress> {
    return (await this.http.delete<types.APIResponse<types.SetupProgress>>(`/setup/steps/${encodeURIComponent(key)}/done`)).data.data;
  }

  async setSetupDismissed(dismissed: boolean): Promise<types.SetupProgress> {
    return (await this.http.put<types.APIResponse<types.SetupProgress>>('/setup/dismissed', { dismissed })).data.data;
  }
}
